import { Header } from '../../components/header'
import { Footer } from '../../components/footer'
import { Banner } from '../../components/bannerHome'
import teamReadyWork from '../../assets/images/teamReadyWork.jpg'
import './style.css'

export function Contato() {
  const handleSubmit = (e) => {
    e.preventDefault()
    alert('Mensagem enviada com sucesso!')
  }

  return (
    <div className="contact-page">
      <Header />
      <Banner
        title="VidaPlus"
        subtitle="Sua solução completa para uma vida mais saudável"
        backgroundImage={`url(${teamReadyWork})`}
      />

      <section className="contact-section">
        <div className="contact-container">
          <h2 className="contact-title">Contato</h2>
          
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-layout">
              <div className="form-left">
                <div className="form-group">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Nome"
                    required
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Email"
                    required
                    className="form-input"
                  />
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    placeholder="Assunto"
                    required
                    className="form-input"
                  />
                </div>

                <button type="submit" className="submit-button">
                  Enviar
                </button>
              </div>

              <div className="form-right">
                <div className="form-group">
                  <textarea
                    id="message"
                    name="message"
                    placeholder="Mensagem"
                    required
                    className="form-textarea"
                    rows="10"
                  ></textarea>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  )
}
